import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client'
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import App from './App';
import { Web3Provider } from './context/Web3Context';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './GlobalStyle';
import { theme } from './Theme';
import * as serviceWorker from './serviceWorker'; 

// Initialize Apollo Client
const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:5001/graphql', // GraphQL endpoint
    cache: new InMemoryCache()
});

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root')); // Use createRoot

// Render the main application
root.render(
    <ApolloProvider client={client}>
        <Web3Provider>
            <ThemeProvider theme={theme}>
                <GlobalStyle />
                <App />
            </ThemeProvider>
        </Web3Provider>
    </ApolloProvider>
);

serviceWorker.register();